import React, { FC } from 'react';

const IconTarjetaTicket: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Icon / Ticket</title>
      <g id="Icon-/-Ticket" stroke="none" strokeWidth="1" fillRule="evenodd">
        <path
          d="M19.081543,2 L22,4.98266602 L22.0441772,4.939 L22.045166,22 L2.06274414,22 L2.06217723,4.932 L4.85327148,2 L19.081543,2 Z M17.25,14 L6.75,14 C6.33578644,14 6,14.3357864 6,14.75 C6,15.1642136 6.33578644,15.5 6.75,15.5 L6.75,15.5 L17.25,15.5 C17.6642136,15.5 18,15.1642136 18,14.75 C18,14.3357864 17.6642136,14 17.25,14 L17.25,14 Z M13.25,10 L6.75,10 C6.33578644,10 6,10.3357864 6,10.75 C6,11.1296958 6.28215388,11.443491 6.64822944,11.4931534 L6.75,11.5 L13.25,11.5 C13.6642136,11.5 14,11.1642136 14,10.75 C14,10.3357864 13.6642136,10 13.25,10 Z M17.25,6 L6.75,6 C6.33578644,6 6,6.33578644 6,6.75 C6,7.12969577 6.28215388,7.44349096 6.64822944,7.49315338 L6.75,7.5 L17.25,7.5 C17.6642136,7.5 18,7.16421356 18,6.75 C18,6.33578644 17.6642136,6 17.25,6 Z"
          id="Combined-Shape"
        />
        <polygon
          id="Rectangle"
          fill="#FFFFFF"
          transform="translate(12.029467, 21.976270) rotate(-45.000000) translate(-12.029467, -21.976270) "
          points="4.96407766 14.9444398 7.78011198 14.8773222 7.74921058 17.7295728 10.5923979 17.6896081 10.5714569 20.5182602 13.4334272 20.5306375 13.3562077 23.3030111 16.1871904 23.2844006 16.2512714 26.1980747 19.087433 26.1846433 19.0948563 29.0752185"
        />
      </g>
    </svg>
  );
};

export default IconTarjetaTicket;
